import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBXNSAJTWT-Ruy2yDAZz-Oi86NiJqfEjQI",
  authDomain: "farmdash-5a8d5.firebaseapp.com",
  projectId: "farmdash-5a8d5",
  storageBucket: "farmdash-5a8d5.firebasestorage.app",
  messagingSenderId: "756887160200",
  appId: "1:756887160200:web:3bb0a95b3d251cb0dc263d",
  measurementId: "G-VHTH8P5Z7S"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

export default app;